import { useQuery } from "@tanstack/react-query";
import { baseBuyer } from "../../src/utils/server/api";
import axios from "axios";

const fetchFavorites = async () => {
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  const response = await axios.get(`${baseBuyer}/product/favorite`, config);
  return response.data;
};

export function useFavoritesData() {
  const query = useQuery({
    queryKey: ["favorites"],
    queryFn: fetchFavorites,
  });

  return query;
}
